const hexToRgb = (hex: string): string | null => {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	return result
		? `rgb(${hexToInt(result, 1)}, ${hexToInt(result, 2)},${hexToInt(result, 3)})`
		: null;
};

const hexToInt = (arr: RegExpExecArray, index: number): number => parseInt(arr[index], 16);

export const getContrastYIQ = (hex: string): 'light' | 'dark' => {
	const rgb = hexToRgb(hex);
	const modifyRgb: Array<string> = rgb
		? rgb
				.substring(4, rgb.length - 1)
				.replace(/ /g, '')
				.split(',')
		: [];
	const yiq: number = modifyRgb?.length
		? (Number(modifyRgb[0]) * 299 + Number(modifyRgb[1]) * 587 + Number(modifyRgb[2]) * 114) / 1000
		: 0;
	return yiq >= 128 ? 'light' : 'dark';
};
